// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 08-08-2025

import { docodeHexResponse } from '../../_common/common.utils';
import productActionTypes from './product.types';

const INITIAL_STATE = {
	addProductDetailsResponse: null,

	updateProductDetailsResponse: null,

	getProductListResponse: null,
	getProductListArr: [],

	fetchProductDetailsResponse: null,
	fetchProductDetailsArr: [],

	fetchCustomProductDetailsResponse: null,
	fetchCustomProductDetailsArr: [],
	fetchCustomProductDetailsMap: {},

	deleteProductDetailsResponse: null,

	getAccountMasterListResponse: null,
	getAccountMasterListArr: [],

	getAllInstrumnetListResponse: null,
	getAllInstrumnetListArr: [],

	getFilterProductListResponse: null,
	getFilterProductListArr: [],
};

const productReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD PRODUCT DETAILS START *********************** */
		case productActionTypes.ADD_PRODUCT_DETAILS_SUCCESS:
			return { ...state, addProductDetailsResponse: action.payload };

		case productActionTypes.ADD_PRODUCT_DETAILS_FAILURE:
			return { ...state, addProductDetailsResponse: action.payload };

		case productActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addProductDetailsResponse: null };
		/** ***************** ADD PRODUCT DETAILS END *********************** */

		/** ***************** UPDATE PRODUCT DETAILS START *********************** */
		case productActionTypes.UPDATE_PRODUCT_DETAILS_SUCCESS:
			return { ...state, updateProductDetailsResponse: action.payload };

		case productActionTypes.UPDATE_PRODUCT_DETAILS_FAILURE:
			return { ...state, updateProductDetailsResponse: action.payload };

		case productActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateProductDetailsResponse: null };
		/** ***************** UPDATE PRODUCT DETAILS END *********************** */

		/** ***************** GET PRODUCT LIST START *********************** */
		case productActionTypes.GET_PRODUCT_LIST_SUCCESS:
			return {
				...state,
				getProductListResponse: action.payload,
				getProductListArr: docodeHexResponse(action.payload, 'GetProductListKey'),
			};

		case productActionTypes.GET_PRODUCT_LIST_FAILURE:
			return { ...state, getProductListResponse: action.payload, getProductListArr: [] };

		case productActionTypes.GET_PRODUCT_LIST_RESPONSE_CHANGED:
			return { ...state, getProductListResponse: null };
		/** ***************** GET PRODUCT LIST END *********************** */

		/** ***************** FETCH PRODUCT DETAILS START *********************** */
		case productActionTypes.FETCH_PRODUCT_DETAILS_SUCCESS:
			return {
				...state,
				fetchProductDetailsResponse: action.payload,
				fetchProductDetailsArr: docodeHexResponse(action.payload, 'FetchProductDetailsKey'),
			};

		case productActionTypes.FETCH_PRODUCT_DETAILS_FAILURE:
			return {
				...state,
				fetchProductDetailsResponse: action.payload,
				fetchProductDetailsArr: [],
			};

		case productActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchProductDetailsResponse: null };
		/** ***************** FETCH PRODUCT DETAILS END *********************** */

		/** ***************** FETCH CUSTOM PRODUCT DETAILS START *********************** */
		case productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_SUCCESS: {
			const decodedData = docodeHexResponse(
				action.payload.successData,
				'GetCustomProductListKey',
			);
			const { productID } = action.payload;
			return {
				...state,
				fetchCustomProductDetailsResponse: action.payload.successData,
				fetchCustomProductDetailsArr: decodedData,
				fetchCustomProductDetailsMap: productID
					? {
							...state.fetchCustomProductDetailsMap,
							[productID]: decodedData,
						}
					: state.fetchCustomProductDetailsMap,
			};
		}

		case productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_FAILURE:
			return {
				...state,
				fetchCustomProductDetailsResponse: action.payload,
				fetchCustomProductDetailsArr: [],
			};

		case productActionTypes.FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchCustomProductDetailsResponse: null,
				fetchCustomProductDetailsMap: {},
			};
		/** ***************** FETCH CUSTOM PRODUCT DETAILS END *********************** */

		/** ***************** DELETE PRODUCT DETAILS START *********************** */
		case productActionTypes.DELETE_PRODUCT_DETAILS_SUCCESS:
			return { ...state, deleteProductDetailsResponse: action.payload };

		case productActionTypes.DELETE_PRODUCT_DETAILS_FAILURE:
			return { ...state, deleteProductDetailsResponse: action.payload };

		case productActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteProductDetailsResponse: null };
		/** ***************** DELETE PRODUCT DETAILS END *********************** */

		/** ***************** GET MATSER ACCOUNT LIST START ************************/
		case productActionTypes.GET_MASTER_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getAccountMasterListResponse: action.payload,
				getAccountMasterListArr: docodeHexResponse(
					action.payload,
					'GetMasterAccountListKey',
				),
			};

		case productActionTypes.GET_MASTER_ACCOUNT_LIST_FAILURE:
			return {
				...state,
				getAccountMasterListResponse: action.payload,
				getAccountMasterListArr: [],
			};

		case productActionTypes.GET_MASTER_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, getAccountMasterListResponse: null };
		/** ***************** GET MATSER ACCOUNT LIST END ************************/

		/** *********************  START GET ALL INSTRUMENT LIST  ******************** */
		case productActionTypes.GET_ALL_INSTRUMENT_LIST_SUCCESS:
			return {
				...state,
				getAllInstrumnetListResponse: action.payload,
				getAllInstrumnetListArr: docodeHexResponse(
					action.payload,
					'GetAllInstrumentListKey',
				),
			};

		case productActionTypes.GET_ALL_INSTRUMENT_LIST_FAILURE:
			return {
				...state,
				getAllInstrumnetListResponse: action.payload,
				getAllInstrumnetListArr: [],
			};

		case productActionTypes.GET_ALL_INSTRUMENT_LIST_RESPONSE_CHANGED:
			return { ...state, getAllInstrumnetListResponse: null };
		/** *********************  END GET ALL INSTRUMENT LIST  ******************** */

		/** ***************** FETCH FILTER PRODUCT LIST START *********************** */
		case productActionTypes.FETCH_FILTER_PRODUCT_LIST_SUCCESS:
			return {
				...state,
				getFilterProductListResponse: action.payload,
				getFilterProductListArr: docodeHexResponse(
					action.payload,
					'GetFilterProductListKey',
				),
			};

		case productActionTypes.FETCH_FILTER_PRODUCT_LIST_FAILURE:
			return {
				...state,
				getFilterProductListResponse: action.payload,
				getFilterProductListArr: [],
			};

		case productActionTypes.FETCH_FILTER_PRODUCT_LIST_RESPONSE_CHANGED:
			return { ...state, getFilterProductListResponse: null };
		/** ***************** FETCH FILTER PRODUCT LIST END *********************** */

		/** *********************  GET PRODUCT DETAILS LIST START ******************** */
		case productActionTypes.GET_PRODUCT_DETAILS_LIST_SUCCESS:
			return {
				...state,
				getProductDetailsListResponse: action.payload,
				getProductDetailsListArr: docodeHexResponse(action.payload, 'getProductDetailsKey'),
			};

		case productActionTypes.GET_PRODUCT_DETAILS_LIST_FAILURE:
			return {
				...state,
				getProductDetailsListResponse: action.payload,
				getProductDetailsListArr: [],
			};

		case productActionTypes.GET_PRODUCT_DETAILS_LIST_RESPONSE_CHANGED:
			return { ...state, getProductDetailsListResponse: null };

		/** *********************  GET PRODUCT DETAILS LIST END ******************** */

		default:
			return state;
	}
};
export default productReducer;
